import Backbone from 'backbone';
import _ from 'underscore';
import ComponentBase from 'components/_base/ComponentBase';

const JPNonTransitGeneralInfo = ComponentBase.extend(
    {
        template: require('./jpNonTransitGeneralInfo.hbs'),

        componentClass: 'jp-non-transit-general',

        identifier: 'jp-non-transit-general',

        constructor(options) {
            options.identifier = this.identifier;
            ComponentBase.prototype.constructor.call(this, options);
            this.widget = options.widget;
            this.componentConstructorClass = options.componentConstructorClass;
            this.travelMode = options.properties.travelMode;
            this.route = options.properties.route;
            this.summary = options.properties.summary;
        },

        initialize(options = {}) {
            this.templateConfig = _.extend(options, {
                componentClass: 'jp-non-transit-general',
                travelMode: options.properties.travelMode,
                route: options.properties.route,
                summary: options.properties.summary
            });
            Backbone.View.prototype.initialize.call(this, options);
            this.render();
        },
    }
);
export default JPNonTransitGeneralInfo;


// WEBPACK FOOTER //
// ./src/components/JPNonTransitGeneralInfo/JPNonTransitGeneralInfo.js